import {YearOfStudy} from "@model/year-of-study";

export interface AnneeEtudeDto {
  id: string;
  code: string;
  libelle: string;
  codeSiel: string;
  codeSielCEFA: string;
  dateDebut: string;
  dateFin: string;
  horsService: boolean;
  ordreTri: number;
  niveaux: string[];
}

export const AnneeEtudeDtoMapper = {
  toDomain: (dto: AnneeEtudeDto): YearOfStudy => ({
    id: dto.id,
    code: dto.code,
    label: dto.libelle,
    sielCode: dto.codeSiel,
    sielCEFACode: dto.codeSielCEFA,
    startDate: dto.dateDebut,
    endDate: dto.dateFin,
    inactive: dto.horsService,
    order: dto.ordreTri,
    levels: dto.niveaux
  })
};